import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AdminService } from 'src/app/admin/admin.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  web_pages: any;
  constructor(private services: AdminService, private snackBar: MatSnackBar, private router: Router) { }

  ngOnInit(): void {
  }

  getWebpages(selectedType: any) {
    window.open(`/webPages/${selectedType}`);
    // this.services.webPagesGet(selectedType).subscribe((response: any) => {
    //   if (response.body?.data?.webpage_link) {
    //     this.web_pages = window.open(response.body?.data?.webpage_link);

    //   } else {
    //     this.snackBar.open('Webpage Not Found', 'Fail', {
    //       duration: 5000
    //     });
    //   }
    // })
  }
}
